module["exports"] = [
  "dog",
  "cat", 
  "snake", 
  "bear", 
  "lion", 
  "cetacean", 
  "insect", 
  "crocodilia", 
  "cow", 
  "bird", 
  "fish", 
  "rabbit", 
  "horse"
]


//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/animal/type.js
// module id = 2574
// module chunks = 1610